export default {
    test: {
      hello: '你好',
      world: '世界'
    },
    common: {
        title: '神农问穹大模型'
      },
    layers: {
      wind: '风速',
      temperature: '温度',
      humidity: '湿度',
      precipitation: '降水',
      more: '更多',
      latlng: '经纬网',
      port: '港口',
      device: '设备库',
      warningLine: '警戒圈',
      pipeLine: '管线',
      ship: '船舶'
    }
  }